// extracted by mini-css-extract-plugin
export default {"login":"OZZW2luR","hasContentBg":"B3pk47ro"};